import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// ** Reducers
import UserSlice from './Started';
import UserAuthSlice from './auth/authSlice';
import LanguageSlice from './language/languageSlice'
import LoginAuthSlice from './auth/loginSlice'


const rootReducer = combineReducers({
  user: UserAuthSlice,
  initialUserInfo: UserSlice,
  language: LanguageSlice,
  login: LoginAuthSlice,
});

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['user', 'language', 'login'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV === 'development',

  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
